import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname) {
  if (!path) return false;
  // Exact match, or a real sub-path (segment boundary). Using matchPath with end:false
  // would wrongly mark "/consumption/fuel" active on "/consumption/fuel-tank", because
  // react-router appends a \b word boundary and "-" counts as one.
  return (
    !!matchPath({ path, end: true }, pathname) ||
    pathname === path ||
    pathname.startsWith(`${path}/`)
  );
}
